<template lang="pug">
  // 主要列表區
  #GPT(style='height: 100vh;').main-page.page-noScroll.upportal-color.pb-0.position-relative
    loading-overlay(v-show='loading' message='Loading . . .' :zIndex='999')

    // 標題行
    div.d-flex.align-center.px-0.pb-0.px-md-2.pb-md-4
      span.ml-4.mr-6(style='font-weight: 500; font-size: 28px; letter-spacing:0.5px; color:#444;') {{ $t('GPT_MENU.KNOWLEDGE') }}
      v-btn.white--text(v-if="show_private_knowledge_add_btn" @click='showAddDialog' height='40' :ripple='false' color='#14C6DE' depressed)
        v-img.mr-1(src="@/assets/images/add-white-thin.png" max-height="16" max-width="16")
        span(style='font-weight: 500; font-size: 16px;') {{ $t("ADD_KNOWLEDGE.TITLE") }}

    // 篩選區
    div.ma-0.mt-3.pa-0.d-flex.align-center.justify-space-between
      v-row.ma-0.pa-0.d-flex.justify-start
        v-col(cols='2' width='100px').px-0.ml-6
          div(style="position: absolute; margin-top:-22px; font-size: 12px; color: #444;") {{$t('GPT_KNOWLEDGE.CATEGORY')}}
          v-select.bg-white(v-model='selectCategory' height='30' dense outlined clearable :placeholder='$t("GPT_KNOWLEDGE.CATEGORY")' :items='category_list' item-value='id' item-text='name')
        v-col(cols='1').px-0.ml-3.mr-1
          v-btn.white--text(@click='act_search' height='40' :ripple='false' color='#14C6DE' depressed)
            v-img.mr-1(src="@/assets/images/search_btn_icon.png" max-height="18" max-width="18")
            span(style='font-weight: 600; font-size: 16px;') {{$t('GENERAL.SEARCH')}}
        v-col(cols='1').px-0.ml-0
          v-btn(text height='40' @click='refresh')
            v-img.mr-1(src="@/assets/images/refresh.png" max-height="16" max-width="16")
            span(style="font-weight: 700; font-size: 16px; color: #14C6DE;") {{$t('GENERAL.REFRESH')}}
        v-col(cols='1').px-0.ml-1
          div.lib_search_bar_style
            v-text-field(v-model='libname_search' flat dense append-icon='icon-search' rounded outlined style='width:200px;' hide-details)

    // 清單內容
    #page-inner.scroll-x.pb-0(style='max-height: calc(84vh) !important;')
      div.card-area(v-if='!loading' style='min-height: calc(79vh) !important; max-height: calc(79vh) !important; overflow: auto;')
        v-container.upgpt-container(max-content)
          v-row.d-flex.align-center.justify-start.pt-2(style="margin-left:11px;")
            v-col(class="mt-1" cols="auto" v-for="(data,index) in filter_knowledges_list" :key='data.id').pl-0.pt-0
              v-hover
                template(v-slot:default="{ hover }")
                  div.UX-knowledges-card.UX-knowledges-card-height(:class="hover ? 'UX-knowledges-card-hover-my-knowledge' : ''")
                    // icon + 標題
                    v-card-title.pa-0.ml-4.mt-1.d-flex.align-center(style="height:48px; width:298px;")
                      div.pa-0.ma-0.d-flex.align-center.justify-start
                        v-img(id='rounded-card' src="@/assets/images/book1.png" width="36px" height="32px" style="margin:6px 6px 4px 0px;")
                        p.ma-0.UX-knowledges-card-title(:title='data.name') {{ data.name }}
                    v-card-text.mt-1.pa-0
                      div.pa-0.ma-0.ml-4
                        p.ma-0.UX-knowledges-card-descriptions(:title='data.description') {{ data.description }}
                    div(style='width:298px; height:28px').mt-2.mx-auto.pa-0.d-flex.align-center.justify-space-between
                      v-col.px-0.d-flex.align-center.justify-center
                        label.UX-switch.mr-1
                          input(v-model='data.active' type="checkbox" @click='openKnowledge(data)')
                          div(class="UX-slider round")
                        span(v-if='data.active' style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                        span(v-else style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
                      v-col.d-flex.align-center.justify-center
                        v-btn.pa-0(@click='toKnowledgeDetail(data.id)' plain  ripple style='width:40px; height:28px;')
                          v-img.mr-1(src="@/assets/images/edit.png" max-height="16" max-width="16")
                          div(style='color:#222222; font-weight: 500; font-size: 14px;') {{$t("GENERAL.EDIT")}}
                      v-col
                        v-btn(@click='onDelete(data.id)' plain style='width:40px; height:28px;')
                          v-icon(size='16' color='#222222') icon-remove
                          div(style='color:#222222; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.DELETE_SIMPLE")}}
                    v-divider.ma-0.mt-1.mb-1.ml-3.mr-3
                    div
                      v-row.pa-0.ma-0(style='max-height: 42px;')
                        v-col.pa-0.d-flex.align-center.justify-start.pl-4(cols="6")
                          p.mt-1.mb-0(:title='data.category' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.CATEGORY")}} :
                          span.ml-1.mt-1(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.category}}
                        v-col.pa-0.d-flex.align-center.justify-start(cols="6")
                          p.mt-1.mb-0(:title='data.docs_count' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.DOCS")}} :
                          span.ml-1.mt-1(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.docs_count}}

    // Dialogs
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='addDialog' width='480' content-class='statusDialog' v-if='addDialog')
      add-dialog(@emitAddDialog='onEmitAddDialog'  :is_private="true")

</template>

<script>
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import addDialog from "@/components/GPT_Dialog/Knowledge/addKnowledge";
import i18n from '/common/plugins/vue-i18n.js';
import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";
import AiBotsService from "@/services/AiBotsService";

export default {
  name: "KnowledgeList",
  props: {
    show_private_knowledge_add_btn: {
    type: Boolean,
    require:true,
    }
  },
  components: {
    loadingOverlay,
    messageDialog,
    successDialog,
    errorDialog,
    addDialog,
  },
  data() {
    return {
      loading:false,
      isDelete:false,
      addDialog:false,
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      Knowledges_list:[],
      filter_knowledges_list:[],
      botList:[],
      deleteId:null,
      bot_background_colors: ['#9ACFFF', '#F6C2C2', '#DEC5F6', '#9ACFFF', '#F6C2C2', '#DEC5F6' ],
      category_list: [],
      selectCategory: null,
      selectUpdateby: null,
      libname_search:'',
    };
  },
  async created() {
    this.loading = true;
    await this.getBotList();
    await this.getListData();
    this.loading = false;
  },
  methods: {
    async getListData() {
      await KnowledgeLibraryService.list_private(false).then((response) => {
        this.Knowledges_list = response.data;
        this.Knowledges_list.forEach(el=>{
          el.docs_count = el.knowledge_detial_set.length;
          el.name = el.name.split('@')[0];
        })
        this.filter_knowledges_list = this.Knowledges_list;
      })
      this.getCategoryListData();
    },
    async getCategoryListData(){
      await KnowledgeLibraryService.getknowledgecategoryoption().then(response=>{
        this.category_list = response.data;
      })
    },
    async getBotList(){
      await AiBotsService.select_list().then((response)=>{
        this.botList = response.data;
      })
      .catch(response => {
          if (response.response.status == 403) {
              this.$router.replace('/upgpt/PermissionError');
          } else if(response.response.status == 404) {
              this.$router.replace('/upgpt/PageNotFound');
          }
      });
    },
    async openKnowledge(data){
      let edit_data = {
        "id" : data.id,
        "active" : !data.active
      }
      await KnowledgeLibraryService.edit(edit_data,true).then(response=>{
        data.active = response.data.active;
      })
    },
      async toKnowledgeDetail(data){
        this.$emit("getKnowledgeDetail", data);
      },
    onDelete(id){
      this.deleteId = id;
      this.isDelete = true;
      this.message = i18n.t("GPT_KNOWLEDGE.DEL_MSG");
      this.messageDialog = true;
    },
    getFormatTime(data){
      let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',hour: '2-digit',minute: '2-digit',hour12: false };
      let today  = new Date(data);
      if(this.$i18n.locale == "zh_TW") {
        return today.toLocaleDateString("zh-TW", options);
      } else {
        return today.toLocaleDateString("en-US", options);
      }
    },
    // Dialog Area
    showAddDialog() {
      this.addDialog = true;
    },
    onEmitAddDialog(val,data){
      if(val && data){
        data.robots = data.linked_bots_and_knowledge_set.map(item=> {return item.ai_bot_id});
        data.robots_count = data.linked_bots_and_knowledge_set.length;
        data.docs_count = data.knowledge_detial_set.length;
        data.name = data.name.split('@')[0];
        this.Knowledges_list.unshift(data);
        this.act_search();
      }
      this.addDialog = false;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog(val) {
      if(val && this.isDelete){
        await KnowledgeLibraryService.delete(this.deleteId, true).then(()=>{
          this.Knowledges_list = this.Knowledges_list.filter(el=>el.id != this.deleteId)
          this.act_search();
        })
      }
      this.isDelete = false;
      this.deleteId = null;
      this.messageDialog = false;
    },
    async act_search() {
      await this.getCategoryListData();
      let temp_arr = []
      this.Knowledges_list.filter(el => {
        if((this.selectCategory == null || this.selectCategory == '') && (this.selectUpdateby == null || this.selectUpdateby == '')){
          if(el.name.includes(this.libname_search)){
            temp_arr.push(el);
          }
        }else if((this.selectCategory != null && this.selectCategory != '') && (this.selectUpdateby == null || this.selectUpdateby == '')){
          if((el.name.includes(this.libname_search)) && (el.category==this.selectCategory)){
            temp_arr.push(el);
          }
        }else if((this.selectCategory == null || this.selectCategory == '') && (this.selectUpdateby != null && this.selectUpdateby != '')){
          if((el.name.includes(this.libname_search)) && (el.updated_by.id==this.selectUpdateby)){
            temp_arr.push(el);
          }
        }else{
          if((el.name.includes(this.libname_search)) && (el.category==this.selectCategory) && (el.updated_by.id==this.selectUpdateby)){
            temp_arr.push(el);
          }
        }
      });
      this.filter_knowledges_list = temp_arr
    },
    async refresh(){
      this.selectCategory = '';
      this.selectUpdateby = '';
      this.libname_search = '';
      await this.getListData();
    },
  },
  watch:{
    "messageDialog":function(){
      if(!this.messageDialog){
        this.isDelete = false;
      }
    },
    "libname_search":function(){
      this.act_search();
    },
  },
}
</script>

<style scoped>
.card-area::-webkit-scrollbar {
  width: 6px;
}
.card-area::-webkit-scrollbar-track {
  background:  #F4F4F4 !important;
}
.card-area::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3) ;
  border-radius: 10px;
}
</style>